import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createBlock(_component_el_menu, {
    "default-active": "2",
    class: "el-menu-vertical-demo",
    collapse: $data.isCollapse,
    onOpen: $options.handleOpen,
    onClose: $options.handleClose,
    "unique-opened": "true",
    "background-color": "#fff"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_menu_item, {
      index: "6",
      onClick: $options.toData
    }, {
      title: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createElementVNode("span", {
        class: "iconfont icon-24gl-fileText",
        style: {
          "margin-right": "5px"
        }
      }, null, -1), _createTextVNode(" 数据展示 ", -1)]))]),
      _: 1
    }, 8, ["onClick"]), $data.authList.indexOf('1') !== -1 || $data.authList.indexOf('2') !== -1 || $data.authList.indexOf('3') !== -1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: 0,
      index: "2"
    }, {
      title: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("任务管理", -1)]))]),
      default: _withCtx(() => [$data.authList.indexOf('1') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 0,
        index: "2-1",
        onClick: _cache[0] || (_cache[0] = $event => $options.toOrder(0))
      }, {
        title: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createElementVNode("span", {
          class: "iconfont icon-24gl-fileText",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createTextVNode(" 任务创建 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), $data.authList.indexOf('2') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        index: "2-2",
        onClick: _cache[1] || (_cache[1] = $event => $options.toOrder2(1))
      }, {
        title: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createElementVNode("span", {
          class: "iconfont icon-fenpei",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createTextVNode(" 任务分配 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), $data.authList.indexOf('3') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 2,
        index: "2-3",
        onClick: $options.toOrderGet
      }, {
        title: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createElementVNode("span", {
          class: "iconfont icon-lingqu",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createTextVNode(" 任务领取 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), $data.authList.indexOf('4') !== -1 || $data.authList.indexOf('5') !== -1 || $data.authList.indexOf('6') !== -1 || $data.authList.indexOf('7') !== -1 || $data.authList.indexOf('8') !== -1 || $data.authList.indexOf('9') !== -1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: 1,
      index: "1"
    }, {
      title: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("检测报告管理", -1)]))]),
      default: _withCtx(() => [$data.authList.indexOf('5') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 0,
        index: "1-1"
      }, {
        title: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("span", {
          class: "iconfont icon-bianzhirenwu",
          style: {
            "margin-right": "5px"
          }
        }, null, -1)), _createElementVNode("span", {
          onClick: _cache[2] || (_cache[2] = (...args) => $options.toWeave && $options.toWeave(...args))
        }, "检测报告编制")]),
        _: 1
      })) : _createCommentVNode("", true), $data.authList.indexOf('6') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        index: "1-2"
      }, {
        title: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("span", {
          class: "iconfont icon-shenhe",
          style: {
            "margin-right": "5px"
          }
        }, null, -1)), _createElementVNode("span", {
          onClick: _cache[3] || (_cache[3] = (...args) => $options.toAudit && $options.toAudit(...args))
        }, "检测报告审核")]),
        _: 1
      })) : _createCommentVNode("", true), $data.authList.indexOf('7') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 2,
        index: "1-3"
      }, {
        title: _withCtx(() => [_cache[15] || (_cache[15] = _createElementVNode("span", {
          class: "iconfont icon-xian-buguize-yanzheng",
          style: {
            "margin-right": "5px"
          }
        }, null, -1)), _createElementVNode("span", {
          onClick: _cache[4] || (_cache[4] = (...args) => $options.toApprove && $options.toApprove(...args))
        }, " 检测报告批准 ")]),
        _: 1
      })) : _createCommentVNode("", true), $data.authList.indexOf('8') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 3,
        index: "1-4"
      }, {
        title: _withCtx(() => [_cache[16] || (_cache[16] = _createElementVNode("span", {
          class: "iconfont icon-chaxun",
          style: {
            "margin-right": "5px"
          }
        }, null, -1)), _createElementVNode("span", {
          onClick: _cache[5] || (_cache[5] = (...args) => $options.toQuery && $options.toQuery(...args))
        }, " 检测报告查询 ")]),
        _: 1
      })) : _createCommentVNode("", true), $data.authList.indexOf('9') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 4,
        index: "1-5"
      }, {
        title: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("span", {
          class: "iconfont icon-shangchuan",
          style: {
            "margin-right": "5px"
          }
        }, null, -1)), _createElementVNode("span", {
          onClick: _cache[6] || (_cache[6] = (...args) => $options.toUpload && $options.toUpload(...args))
        }, " 检测数据上传 ")]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), $data.authList.indexOf('14') !== -1 || $data.authList.indexOf('15') !== -1 || $data.authList.indexOf('16') !== -1 || $data.authList.indexOf('18') !== -1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: 2,
      index: "4"
    }, {
      title: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("业务管理", -1)]))]),
      default: _withCtx(() => [$data.authList.indexOf('14') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 0,
        index: "4-1",
        onClick: $options.toDevice
      }, {
        title: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createElementVNode("span", {
          class: "iconfont icon-office-building",
          style: {
            "margin-right": "10px"
          }
        }, null, -1), _createTextVNode(" 设备管理 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_menu_item, {
        index: "4-5",
        onClick: $options.toDeviceStatus
      }, {
        title: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createElementVNode("span", {
          class: "iconfont icon-shebeizhuangtai",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createElementVNode("span", null, "设备状态", -1)]))]),
        _: 1
      }, 8, ["onClick"]), $data.authList.indexOf('15') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        index: "4-2",
        onClick: $options.toTemplate
      }, {
        title: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createElementVNode("span", {
          class: "iconfont icon-caidan",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createElementVNode("span", null, "检测模板管理", -1)]))]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), $data.authList.indexOf('16') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 2,
        index: "4-3",
        onClick: $options.toSeal
      }, {
        title: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createElementVNode("span", {
          class: "iconfont icon-shenhe",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createElementVNode("span", null, "电子印章上传", -1)]))]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), $data.authList.indexOf('18') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 3,
        index: "4-4",
        onClick: $options.toState
      }, {
        title: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createElementVNode("span", {
          class: "iconfont icon-shengming",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createElementVNode("span", null, "符合性声明", -1)]))]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), $data.authList.indexOf('11') !== -1 || $data.authList.indexOf('12') !== -1 || $data.authList.indexOf('19') !== -1 || $data.authList.indexOf('21') !== -1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: 3,
      index: "3"
    }, {
      title: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("系统设置", -1)]))]),
      default: _withCtx(() => [$data.authList.indexOf('11') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 0,
        index: "3-1",
        onClick: $options.toRole
      }, {
        title: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createElementVNode("span", {
          class: "iconfont icon-quanxian",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createTextVNode(" 权限管理 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), $data.authList.indexOf('12') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        index: "3-2",
        onClick: $options.toUser
      }, {
        title: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createElementVNode("span", {
          class: "iconfont icon-jurassic_user",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createTextVNode(" 用户管理 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), $data.authList.indexOf('19') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 2,
        index: "3-4",
        onClick: $options.toTool
      }, {
        title: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createElementVNode("span", {
          class: "iconfont icon-gongjuxiang",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createTextVNode(" 工具箱管理 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), $data.authList.indexOf('21') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 3,
        index: "3-5",
        onClick: $options.toCap
      }, {
        title: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createElementVNode("span", {
          class: "iconfont icon-a-005_anquanmao",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createTextVNode(" 安全帽管理 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), $data.authList.indexOf('22') !== -1 || $data.authList.indexOf('23') !== -1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: 4,
      index: "5"
    }, {
      title: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode("支付管理", -1)]))]),
      default: _withCtx(() => [$data.authList.indexOf('22') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 0,
        index: "5-1",
        onClick: $options.toPay
      }, {
        title: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createElementVNode("span", {
          class: "iconfont icon-quanxian",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createTextVNode(" 购买会员 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), $data.authList.indexOf('23') !== -1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        index: "5-2",
        onClick: $options.toOrderinfo
      }, {
        title: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createElementVNode("span", {
          class: "iconfont icon-jurassic_user",
          style: {
            "margin-right": "5px"
          }
        }, null, -1), _createTextVNode(" 订单管理 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["collapse", "onOpen", "onClose"]);
}